export function designInfo(job) {
    let dateText = " ";
    let date = " ";
    let popup = "No info available";

    if (job.designStatus === "NO DESIGNS") {
        dateText = "Job assigned to design team: ";
        date = job.dates.designsRequested;
        popup = "New";
    } else if (job.designStatus === "DESIGNS UPLOADED") {
        dateText = "Designs uploaded: ";
        date = job.dates.designsUploaded;
        popup = "Designs uploaded";
    } else if (job.designStatus === "DESIGN CHOSEN") {
        dateText = "Final design chosen: ";
        date = job.dates.designChosen;
        popup = "Final design chosen";
    } else if (job.designStatus === "COMPLETE") {
        dateText = "Design job completed: ";
        date = job.dates.designsCompleted;
        popup = "Design Completed";
    }

    return [dateText, date, popup];

}